<template lang="pug">
.comments-send
  .comments-send__value
    .comments-send__comment
      .comments-send__title
        | Ответ на комментарий
      .comments-send__send
        input.comments-send__input(
          v-model="contentLocal.message",
          @keyup.enter="sendData",
          placeholder="Напиши ответ к комментарию"
        )
        UploadFiles.comments-send__upload(
          @getFiles="getFiles"
          :fileExt="fileExt"
          :fileMime="fileMime"
          :multiple="true"
          :isIcon="true",
          :hugeFiles="true"

          icon="uploadFiles",
          buttonText="",
          v-tiny-text-tooltip="{text: 'Загрузить файлы'}"
        )
    Icon.comments-send__btn(
      v-tiny-text-tooltip="{text: 'Отправить комментарий'}",
      icon="send",
      @click="sendData"
    )
  .comments-send__files
    File(
      v-for="file in contentLocal.files" :key="file.id"
      :file="file"
      icon="image"
      @deleteFile="addFileToDelete(file)"
    )
</template>
<script>
import File from '@/components/File/File';

export default {
  components: { File },
  props: {
    text: {},
    files: {}
  },
  data() {
    return {
      contentLocal: {
        message: '',
        files: []
      },
      isSendComment: false,
      errorData: '',
      uploadingFiles: false,
      filesToDelete: [],
      fileExt: ['.odt', '.docx'],
      fileMime: [
        'image/*',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'text/csv'
      ]
    };
  },
  mounted() {
    if (this.text) {
      this.contentLocal.message = this.text;
    }
    if (this.files) {
      this.contentLocal.files = this.files;
    }
  },
  methods: {
    sendData() {
      if (this.contentLocal.message || this.contentLocal.files.length) {
        this.$emit('send', {
          commentatorFiles: this.contentLocal.files,
          text: this.contentLocal.message
        });
        this.clear();
      }
    },
    async getFiles({ formData }) {
      this.uploadingFiles = true;
      const files = await this.$store.dispatch('ajax/uploadFile', { formData });
      this.uploadingFiles = false;
      if (files) {
        files.forEach(f => {
          this.contentLocal.files.push(f);
        });
      }
    },
    async addFileToDelete(file) {
      this.filesToDelete.push(file);
      const fileIdx = this.contentLocal.files.findIndex(f => f.id === file.id);
      if (fileIdx !== -1) {
        this.contentLocal.files.splice(fileIdx, 1);
        this.contentLocal.files = [...this.contentLocal.files];
      }
    },
    clear() {
      this.contentLocal = {
        message: '',
        file: ''
      };
    }
  }
};
</script>
